export default function($) {
    "use strict";
    $('.js-ingredient-tab-link').on('click', function(e) {
        e.preventDefault();
        $('.js-ingredient-body:not(.u-hide)').addClass('u-hide');
        $(this.hash).removeClass('u-hide');
    });
}
